import { PaginatedDataDTO, PaginationDTO, PaginationRestDTO } from '@bottega52/commons-pagination';
import _ from 'lodash';
import { IDemoPlantInDTO } from '../repository/jago/model/input/IDemoPlantInDTO';

export function decode(data: PaginationRestDTO<IDemoPlantInDTO>): PaginatedDataDTO<IDemoPlantInDTO> {
  const pagination: PaginationDTO = _.omit(data, 'content');
  return {
    content: data.content,
    pagination,
  };
}